import Phaser from 'phaser'
import React, { useEffect } from 'react'
import HomeScene from './scenes/homeScene'

export default function GameController({
  defaultPoints,
  isMobile = false,
  onFinishGame,
  onShowQuestion,
}) {
  var Game
  const innerHeight = window.innerHeight
  const innerWidth = window.innerWidth
  const minSize = {
    height: isMobile ? 750 : 800,
  }

  const DIMENTIONS = {
    Y:
      (innerHeight < 760
        ? minSize.height
        : innerHeight > 900
        ? 900
        : innerHeight) - (isMobile ? 85 : 200),
    X:
      (innerWidth < 320 ? 320 : innerWidth > 1600 ? 1600 : innerWidth) -
      (isMobile ? 0 : 40),
  }

  var CONFIG = {
    type: Phaser.AUTO,
    width: DIMENTIONS.X,
    height: DIMENTIONS.Y,
    parent: 'curv-game',
    transparent: true,
    scene: [HomeScene],
  }

  useEffect(() => {
    if (!Game) {
      Game = new Phaser.Game(CONFIG)
      Game.reactProps = {
        onFinishGame,
        isMobile,
        defaultPoints,
        onShowQuestion,
      }
    }
  }, [])

  return (
    <div className="curv-game" id="curv-game">
      {Game}
    </div>
  )
}
